import { heroLead, heroSide, siteMeta } from "@/mocks/home";
import { showToast } from "@/hooks/useToast";
import Reveal from "@/components/base/Reveal";

export default function HeroEditorial() {
  return (
    <section id="top-story" className="scroll-mt-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 pb-4 pt-6 md:px-6 md:pt-8">
        <Reveal className="flex flex-wrap items-end justify-between gap-3 border-b border-background-300/70 pb-3">
          <p className="flex items-center gap-2 text-xs tracking-widest text-foreground-500">
            <span className="font-medium text-foreground-800">{siteMeta.issue}</span>
            <span className="text-background-400">/</span>
            <span>{siteMeta.edition}</span>
            <span className="text-background-400">/</span>
            <span>{siteMeta.updatedAt}</span>
          </p>
          <p className="text-xs text-foreground-500">本页为单页内参，所有模块可直接浏览</p>
        </Reveal>

        <div className="mt-4 grid grid-cols-1 gap-3 lg:grid-cols-3 md:gap-4">
          <Reveal className="lg:col-span-2">
            <article className="group relative h-[380px] overflow-hidden rounded-lg border border-background-300/70 md:h-[460px]">
              <img
                src={heroLead.image}
                alt="88看料本期头条封面：内部隐藏内容的深层观察"
                title="88看料 本期头条 内部隐藏内容 深层观察"
                className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/90 via-foreground-950/55 to-foreground-950/25" />
              <div className="absolute inset-0 flex flex-col justify-end p-5 md:p-7">
                <span className="mb-3 w-fit rounded-md bg-accent-500 px-2.5 py-1 text-xs font-medium text-foreground-950">
                  {heroLead.kicker}
                </span>
                <h2 className="font-heading max-w-2xl text-2xl font-bold leading-snug text-background-50 md:text-[34px]">
                  {heroLead.title}
                </h2>
                <p className="mt-3 hidden max-w-xl text-sm leading-relaxed text-background-100/85 sm:block">
                  {heroLead.excerpt}
                </p>
                <div className="mt-5 flex flex-wrap items-center gap-4">
                  <button
                    type="button"
                    onClick={() => showToast("已打开本期头条全文（演示内容）")}
                    className="flex items-center gap-1.5 rounded-md bg-background-50 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-background-100 whitespace-nowrap"
                  >
                    {heroLead.cta}
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-arrow-right-line" aria-hidden="true" />
                    </span>
                  </button>
                  <div className="flex flex-wrap gap-3 text-xs text-background-100/80">
                    {heroLead.meta.map((item) => (
                      <span key={item}>{item}</span>
                    ))}
                  </div>
                </div>
              </div>
            </article>
          </Reveal>

          <div className="grid grid-cols-1 gap-3 md:gap-4">
            {heroSide.map((item, index) => (
              <Reveal key={item.title} delay={index * 90}>
                <article className="group flex h-full flex-col justify-between rounded-lg border border-background-300/70 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5">
                  <div>
                    <div className="mb-3 flex items-center justify-between">
                      <span className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.meta}</span>
                    </div>
                    <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 md:text-lg">
                      {item.title}
                    </h3>
                  </div>
                  <span className="mt-4 flex items-center gap-1 text-xs text-foreground-500 transition-colors group-hover:text-primary-600">
                    查看条目
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-arrow-right-s-line" aria-hidden="true" />
                    </span>
                  </span>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}